<template>
  <v-container>
    <v-row align-content="center">
      <v-col cols="12">
        <media/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import media from "@/components/Library/Media"

export default {
  components: {
    media,
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
